import { render, staticRenderFns } from "./SubFoldersModal.vue?vue&type=template&id=86ffb342&"
import script from "./SubFoldersModal.vue?vue&type=script&lang=ts&"
export * from "./SubFoldersModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports